import IndividualFilesPage from '../pages/individuals/[individualId].vue'
import EntityFilesPage from '../pages/entities/[entityId].vue'
import OtherEntityFilesPage from '../pages/otherEntities/[otherEntityId].vue'
import GroupFilesPage from '../pages/groups/index.vue'

export default [
  {
    component: EntityFilesPage,
    name: 'filing.entity.files-system',
    path: '/:slug/filing/:entity_type/:entity_id/files-system',
  },
  {
    component: IndividualFilesPage,
    name: 'filing.individual.files-system',
    path: '/:slug/filing/individual/:individual_id/files-system',
  },
  {
    component: OtherEntityFilesPage,
    name: 'filing.other-entity.files-system',
    path: '/:slug/filing/associated-entity/:other_entity_id/files-system',
  },
  {
    component: GroupFilesPage,
    name: 'filing.group.files-system',
    path: '/:slug/filing/files-system',
  },
]
